<div
    class="cipo-outlined-field"
    [class.compact-mode]="compactMode()"
    [class.cipo-mark-changed]="markChanged()"
    [class.cipo-error]="error()"
    [ngClass]="[bgColorClass() ?? defaultBgColorClass]">
    @if (label()) {
        <div class="cipo-outlined-label">
            {{ label() | translate }}
            @if (required()) {
                <span class="required-star">*</span>
            }
        </div>
    }
    <div class="cipo-outlined-content">
        <ng-content></ng-content>
    </div>
</div>
